import React, { useMemo } from "react";

import { Car } from "../../../../../../services";
import { CellContentRoot } from "../../../../../LightTable";

const AliasesCellContent: React.FC<AliasesCellContent.Props> = ({ item }) => {
	const content = useMemo(
		() =>
			item.executors
				?.map((executor) => executor?.alias || "")
				?.join(", ") ?? "",
		[item.executors],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace AliasesCellContent {
	interface Props {
		item: Car.Model;
	}
}

export default AliasesCellContent;
